import { Container } from '@mui/material';
import React from 'react'
import DesktopMenu from './component/DesktopMenu';
import MobileMenu from './component/MobileMenu';
import Twitter from "../../../assets/images/twitter.png"
import Telegram from "../../../assets/images/telegram.png"

const LockerMenu = (props) => {
    const menuList = [ // You can pass 4 perameters for menu title, link, target and customClass
        {
        title: "Home",
        link: "/#home",
        },
        {
        title: " About",
        link: "/#about",
        },                 
        {
        title: "Pehnomics",
        link: "/#pehnomics",
        },
        {
        title: "How to Buy",
        link: "/#howtobuy",
        target: "blank",
        },
        {
          title: <img src={Twitter}/>,
          link: "https://t.me/pehpehcoineth",
          target: "blank",
        },
        {
        title: <img src={Telegram}/>,
        link: "https://twitter.com/pehpehcoineth",
        target: "blank",
        },
    ];
  return (
    <div maxWidth="xl"
    data-aos="fade-zoom-in"
    data-aos-easing="ease-in"
    data-aos-delay="400"
    data-aos-offset="0"
    data-aos-duration="500">
        <DesktopMenu menuList={menuList} />
        <MobileMenu menuList={menuList} />
    </div>
  )
}

export default LockerMenu